import React from 'react';

import useStoreTranslation from 'hooks/useStoreTranslation';

import { Info } from '../styles';
import { HotelWrapper, BedIcon, HotelName } from './styles';

type Props = {
  hotelDetails: {
    cityName: string;
    checkIn: Date | string;
    checkOut: Date | string;
    quantityDays: number;
  };
};

const Hotel = ({ hotelDetails }: Props) => {
  const { t } = useStoreTranslation();

  return (
    <HotelWrapper>
      <BedIcon />
      <div>
        <HotelName>{t('tripCard.hotelIn', { cityName: hotelDetails.cityName })}</HotelName>
        <Info>
          {t('tripCard.bookingDate', { date: new Date(hotelDetails.checkIn) })} &mdash;{' '}
          {t('tripCard.bookingDate', { date: new Date(hotelDetails.checkOut) })}
        </Info>
        <Info>{t('tripCard.night', { count: hotelDetails.quantityDays })}</Info>
      </div>
    </HotelWrapper>
  );
};

export default Hotel;
